export default __webpack_public_path__ + "static/apple-icon-180x180-a1d7c52e24445a056040d0d3be68844b.png";